function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $fde9406d76ec24a9$exports = {};
var $3e35c426ba278706$exports = {};

$parcel$export($3e35c426ba278706$exports, "getCookieValue", () => $3e35c426ba278706$export$2edfe291d87a018a);
function $3e35c426ba278706$export$2edfe291d87a018a(cookieName) {
    const cookieSplit = ("; " + document.cookie).split("; " + cookieName + "=");
    return cookieSplit.length === 2 ? cookieSplit.pop().split(";").shift() : undefined;
}


var $03ed50ec9aa498e4$exports = {};

$parcel$export($03ed50ec9aa498e4$exports, "delay", () => $03ed50ec9aa498e4$export$1391212d75b2ee65);
function $03ed50ec9aa498e4$export$1391212d75b2ee65(timeInMillis) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), timeInMillis));
}


var $a21f561826ffcdcd$exports = {};

$parcel$export($a21f561826ffcdcd$exports, "getDebugGroup", () => $a21f561826ffcdcd$export$c70183eb5acc76d7);
function $a21f561826ffcdcd$export$c70183eb5acc76d7() {
    const searchParams = new URLSearchParams(window.location.search.substring(1));
    if (Boolean(searchParams.get("adengine_debug"))) return searchParams.get("adengine_debug");
    return searchParams.get("identity_debug");
}


var $c2035a1db49f4079$exports = {};

$parcel$export($c2035a1db49f4079$exports, "localStorageHelper", () => $c2035a1db49f4079$export$2a8d33e352660a9b);
class $c2035a1db49f4079$export$2a8d33e352660a9b {
    constructor(key, ttlInMilliseconds = 60000){
        this.key = key;
        this.ttlInMilliseconds = ttlInMilliseconds;
        let localStorageAvailable = false;
        try {
            localStorageAvailable = window.localStorage !== undefined && window.localStorage !== null;
            if (localStorageAvailable) {
                window.localStorage.setItem("__test__", "test");
                window.localStorage.removeItem("__test__");
            }
        } catch (e) {
            localStorageAvailable = false;
        }
        const fallbackStorageAdapter = {
            getItem: (key)=>window?.instantConfigCache?.[key] ?? null,
            setItem: (key, value)=>{
                if (window.instantConfigCache === undefined) window.instantConfigCache = {};
                window.instantConfigCache[key] = value;
            }
        };
        this.storageAdapter = {
            getItem: (key)=>{
                try {
                    if (localStorageAvailable) return window.localStorage.getItem(key) ?? fallbackStorageAdapter.getItem(key);
                    return fallbackStorageAdapter.getItem(key);
                } catch (e) {
                    return fallbackStorageAdapter.getItem(key);
                }
            },
            setItem: (key, value)=>{
                try {
                    if (localStorageAvailable) return localStorage.setItem(key, value);
                    fallbackStorageAdapter.setItem(key, value);
                } catch (e) {
                    fallbackStorageAdapter.setItem(key, value);
                }
            }
        };
    }
    set(data) {
        const objectToStore = this.getObjectToStore(data);
        this.storageAdapter.setItem(this.key, JSON.stringify(objectToStore));
    }
    get() {
        const storedValue = this.storageAdapter.getItem(this.key);
        return !storedValue ? null : this.parseStoredValue(JSON.parse(storedValue));
    }
    expired(ttl) {
        return ttl ? ttl < Date.now() : true;
    }
    getObjectToStore(data) {
        return {
            data: data,
            ttl: Date.now() + this.ttlInMilliseconds
        };
    }
    parseStoredValue(storedValue) {
        return this.expired(storedValue?.ttl) ? null : storedValue.data;
    }
}


var $04414f269012599f$exports = {};

$parcel$export($04414f269012599f$exports, "lock", () => $04414f269012599f$export$6a9f04c98a658ecb);
$parcel$export($04414f269012599f$exports, "release", () => $04414f269012599f$export$23d3fad09dc44362);

const $04414f269012599f$var$storage = new (0, $c2035a1db49f4079$export$2a8d33e352660a9b)("instant-config-lock", 1000);
function $04414f269012599f$export$6a9f04c98a658ecb() {
    if ($04414f269012599f$var$storage.get() === "lock") return true;
    $04414f269012599f$var$storage.set("lock");
    return false;
}
function $04414f269012599f$export$23d3fad09dc44362() {
    $04414f269012599f$var$storage.set(null);
}


var $0702e0181ae031d6$exports = {};

$parcel$export($0702e0181ae031d6$exports, "getTimeDelta", () => $0702e0181ae031d6$export$85f2155d703a252d);
$parcel$export($0702e0181ae031d6$exports, "logger", () => $0702e0181ae031d6$export$af88d00dbe7f521);
$parcel$export($0702e0181ae031d6$exports, "warner", () => $0702e0181ae031d6$export$73a23a961d4d2188);

const $0702e0181ae031d6$var$debugGroup = (0, $a21f561826ffcdcd$export$c70183eb5acc76d7)() || "";
const $0702e0181ae031d6$var$groups = $0702e0181ae031d6$var$debugGroup.split(",");
const $0702e0181ae031d6$var$BACKUP_ORIGIN_TIME = Date.now();
function $0702e0181ae031d6$export$85f2155d703a252d() {
    const currentTimeStamp = Date.now();
    const originTime = window.performance?.timeOrigin ?? $0702e0181ae031d6$var$BACKUP_ORIGIN_TIME;
    const delta = currentTimeStamp - originTime;
    const secondsResult = delta / 1000;
    return secondsResult.toFixed(4);
}
function $0702e0181ae031d6$export$af88d00dbe7f521(logGroup, ...logValues) {
    if ($0702e0181ae031d6$var$debugGroup === "") return;
    if ($0702e0181ae031d6$var$debugGroup === "1" || $0702e0181ae031d6$var$groups.indexOf(logGroup) !== -1) window.console.info(`${$0702e0181ae031d6$export$85f2155d703a252d()}s\t\t ${logGroup}`, logValues);
}
function $0702e0181ae031d6$export$73a23a961d4d2188(warnGroup, ...warnValues) {
    if ($0702e0181ae031d6$var$debugGroup === "") return;
    if ($0702e0181ae031d6$var$debugGroup === "1" || $0702e0181ae031d6$var$groups.indexOf(warnGroup) !== -1) window.console.warn(warnGroup, warnValues);
}


$parcel$exportWildcard($fde9406d76ec24a9$exports, $3e35c426ba278706$exports);
$parcel$exportWildcard($fde9406d76ec24a9$exports, $03ed50ec9aa498e4$exports);
$parcel$exportWildcard($fde9406d76ec24a9$exports, $a21f561826ffcdcd$exports);
$parcel$exportWildcard($fde9406d76ec24a9$exports, $c2035a1db49f4079$exports);
$parcel$exportWildcard($fde9406d76ec24a9$exports, $04414f269012599f$exports);
$parcel$exportWildcard($fde9406d76ec24a9$exports, $0702e0181ae031d6$exports);


var $a3cb38fbe085f101$exports = {};
var $d958a73fda15a350$exports = {};

$parcel$export($d958a73fda15a350$exports, "InstantConfigInterpreter", () => $d958a73fda15a350$export$482d435527222f10);

var $a88c9511bd498193$exports = {};
var $a85245e4506a9460$exports = {};


var $f871a27651c133e3$exports = {};

$parcel$export($f871a27651c133e3$exports, "shouldBeListOfConfigGroups", () => $f871a27651c133e3$export$15fd8a4b2579d62a);
$parcel$export($f871a27651c133e3$exports, "hasSampling", () => $f871a27651c133e3$export$f348545466c9b18e);
function $f871a27651c133e3$export$15fd8a4b2579d62a(obj) {
    return Array.isArray(obj) && obj.length > 0 && typeof obj[0] === "object";
}
function $f871a27651c133e3$export$f348545466c9b18e(g) {
    const sampling = g.sampling ?? g.s;
    return typeof sampling === "number" && sampling > 0 && sampling < 100;
}


var $dfc1c5a6e0522627$exports = {};


var $43c9ddbbddf7f628$exports = {};


var $7f3485ff2f02714c$exports = {};


var $c4d608724f772f36$exports = {};


var $cb9a978bd0d86e99$exports = {};


var $520d0b7168614bab$exports = {};


var $d4594c0e01298382$exports = {};

$parcel$export($d4594c0e01298382$exports, "negativePrefix", () => $d4594c0e01298382$export$6a1a21b83e21c671);
$parcel$export($d4594c0e01298382$exports, "cacheSuffix", () => $d4594c0e01298382$export$4940459403f61e72);
$parcel$export($d4594c0e01298382$exports, "samplingSeparator", () => $d4594c0e01298382$export$8c99e8be8e35246);
$parcel$export($d4594c0e01298382$exports, "worldWide", () => $d4594c0e01298382$export$aea6dbf29fd09cb3);
$parcel$export($d4594c0e01298382$exports, "precision", () => $d4594c0e01298382$export$b70eeb0e623ceb0d);
$parcel$export($d4594c0e01298382$exports, "experimentBucketSettingKey", () => $d4594c0e01298382$export$120f2aee7d622861);
const $d4594c0e01298382$export$6a1a21b83e21c671 = "non-";
const $d4594c0e01298382$export$4940459403f61e72 = "-cached";
const $d4594c0e01298382$export$8c99e8be8e35246 = "/";
const $d4594c0e01298382$export$aea6dbf29fd09cb3 = "XX";
const $d4594c0e01298382$export$b70eeb0e623ceb0d = 10 ** 6;
const $d4594c0e01298382$export$120f2aee7d622861 = "eb";


$parcel$exportWildcard($a88c9511bd498193$exports, $a85245e4506a9460$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $f871a27651c133e3$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $dfc1c5a6e0522627$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $43c9ddbbddf7f628$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $7f3485ff2f02714c$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $c4d608724f772f36$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $cb9a978bd0d86e99$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $520d0b7168614bab$exports);
$parcel$exportWildcard($a88c9511bd498193$exports, $d4594c0e01298382$exports);



/**
 * Default bucket value for when exp_bucket cookie is not set and no query param is found.
 */ const $38d16649fae24a5f$var$defaultBucket = "100";
/**
 * Regex to check if the cookie is in the new format of `v<version>-<bucket number>`. The old format
 * was just `<bucket number>`. This change was implemented April 2025.
 */ const $38d16649fae24a5f$var$newCookieFormatRegex = /^(?:v\d+-)?(\d{2})$/;
function $38d16649fae24a5f$export$706c348d2e160d8b() {
    const searchParams = new URLSearchParams(window.location.search.substring(1));
    const forcedBucket = searchParams.get("pf_pathfinder_force_bucket");
    const experimentBucket = (0, $3e35c426ba278706$export$2edfe291d87a018a)("exp_bucket");
    let bucketValue = forcedBucket ?? experimentBucket;
    // If this is in the new format, then grab the bucket number only
    const matches = bucketValue?.match($38d16649fae24a5f$var$newCookieFormatRegex);
    if (matches && matches.length >= 2) bucketValue = matches[1];
    return ()=>Number(bucketValue ?? $38d16649fae24a5f$var$defaultBucket);
}



class $e60b87c9ea0c2612$export$43b1cb036f284cbe {
    constructor(icExperimentBucket, container, settingsRepository){
        this.container = container;
        this.settingsRepository = settingsRepository;
        if (typeof icExperimentBucket === "number") this.experimentBucket = this.manageSampling(icExperimentBucket);
        else if (icExperimentBucket === true) this.experimentBucket = this.manageSampling(0);
        else if (icExperimentBucket === false) this.clean();
    }
    build() {
        return ()=>this.experimentBucket ?? $e60b87c9ea0c2612$export$43b1cb036f284cbe.getRandomBucket();
    }
    static getRandomBucket() {
        return Math.floor(Math.random() * 100);
    }
    manageSampling(ttl) {
        let result = this.readFromLoaderVariable() ?? this.readFromSettings() ?? $e60b87c9ea0c2612$export$43b1cb036f284cbe.getRandomBucket();
        if (result === 100) // FIX: Getting rid of the redundant bucket
        result = 0; // and changing the % share of the underrepresented one
         // see more in TACO-1003
        this.storeInLoaderVariable(result);
        this.storeInSettings(result, ttl);
        return result;
    }
    readFromLoaderVariable() {
        return this.container.fandomContext?.experimentBucket;
    }
    readFromSettings() {
        const value = this.settingsRepository && this.settingsRepository.get((0, $d4594c0e01298382$export$120f2aee7d622861));
        return value && Number(value);
    }
    storeInSettings(sampling, ttl) {
        if (this.settingsRepository) this.settingsRepository.set((0, $d4594c0e01298382$export$120f2aee7d622861), sampling.toString(), ttl);
    }
    storeInLoaderVariable(sampling) {
        this.container.fandomContext = this.container.fandomContext || {};
        this.container.fandomContext.experimentBucket = sampling;
    }
    clean() {
        if (this.settingsRepository) this.settingsRepository.remove((0, $d4594c0e01298382$export$120f2aee7d622861));
    }
}


class $eb12f1054b8a7c9d$export$9c1e7db2884bc03 {
    activeKeyValues = [];
    activeLabradorKeyValues = [];
    constructor(icLABradorGamKeyValues){
        if (Array.isArray(icLABradorGamKeyValues)) this.keyValueNamesMap = icLABradorGamKeyValues.map((v)=>v && v.toString().split(":")).filter((v)=>v && v.length >= 2).reduce((acc, v)=>{
            acc[v[0]] = v[1];
            return acc;
        }, {});
        else this.keyValueNamesMap = {};
    }
    getActiveKeyValues() {
        return this.activeKeyValues;
    }
    getActiveLabradorKeyValues() {
        return this.activeLabradorKeyValues;
    }
    mark(key, bucketingResult) {
        const labradorKeyValue = bucketingResult?.isActive ? bucketingResult.keyVal : bucketingResult?.defaultKeyVal;
        if (bucketingResult) {
            const keyValue = this.generateKeyValue(bucketingResult.isActive, bucketingResult.enabledTraffic, key);
            if (!this.activeKeyValues.includes(keyValue)) this.activeKeyValues.push(keyValue);
        }
        if (labradorKeyValue && !this.activeLabradorKeyValues.includes(labradorKeyValue)) this.activeLabradorKeyValues.push(labradorKeyValue);
    }
    /**
	 * @deprecated
	 */ deprecatedMark(key, sampling, active) {
        const keyValue = this.generateKeyValue(active, sampling, key);
        const labradorKeyValue = this.keyValueNamesMap[keyValue] ?? keyValue;
        if (!this.activeKeyValues.includes(keyValue)) this.activeKeyValues.push(keyValue);
        if (!this.activeLabradorKeyValues.includes(labradorKeyValue)) this.activeLabradorKeyValues.push(labradorKeyValue);
    }
    generateKeyValue(active, sampling, key) {
        const traffic = active ? sampling : 100 - sampling;
        const group = active ? "B" : "A";
        return `${key}_${group}_${traffic}`;
    }
}


var $a804696539f008f1$exports = {};
var $e6863e4cd836deaf$exports = {};

$parcel$export($e6863e4cd836deaf$exports, "BrowserMatcher", () => $e6863e4cd836deaf$export$4505b7bf40f87994);
var $0669816a8a22a9c5$exports = {};

$parcel$export($0669816a8a22a9c5$exports, "extractNegation", () => $0669816a8a22a9c5$export$a3f4cf710f4ee0af);

function $0669816a8a22a9c5$export$a3f4cf710f4ee0af(input) {
    return input.startsWith((0, $d4594c0e01298382$export$6a1a21b83e21c671)) ? {
        value: input.replace((0, $d4594c0e01298382$export$6a1a21b83e21c671), ""),
        negated: true
    } : {
        value: input,
        negated: false
    };
}


class $e6863e4cd836deaf$export$4505b7bf40f87994 {
    constructor(currentBrowser){
        this.currentBrowser = currentBrowser?.toLowerCase();
    }
    isValid(group) {
        const browsers = group.b ?? group.browsers ?? [];
        const browserObjects = browsers.map((browser)=>browser.toLowerCase()).map((browser)=>(0, $0669816a8a22a9c5$export$a3f4cf710f4ee0af)(browser));
        if (browsers.length === 0) return true;
        if (!this.currentBrowser) return true; // FIXME: na pewno? unit test
        if (this.isCurrentNegated(this.currentBrowser, browserObjects)) return false;
        return browserObjects.some((object)=>this.currentBrowser.includes(object.value) !== object.negated);
    }
    isCurrentNegated(currentBrowser, browserObjects) {
        return browserObjects.some((object)=>currentBrowser.includes(object.value) && object.negated);
    }
}


var $03b3b9fef850175d$exports = {};

$parcel$export($03b3b9fef850175d$exports, "getBucketing", () => $03b3b9fef850175d$export$bf31116732bec244);
$parcel$export($03b3b9fef850175d$exports, "BucketingMatcher", () => $03b3b9fef850175d$export$c28579e888e7e37b);

function $03b3b9fef850175d$var$mapToRegularBucketing(short) {
    return {
        source: short.s,
        rules: {
            defaultKeyValue: short.r.k,
            ranges: short.r.r.map((range)=>({
                    start: range.s,
                    end: range.e,
                    keyValue: range.k
                }))
        }
    };
}
function $03b3b9fef850175d$export$bf31116732bec244(g) {
    return g?.bucketing ?? (g?.bu !== undefined ? $03b3b9fef850175d$var$mapToRegularBucketing(g.bu) : undefined);
}
class $03b3b9fef850175d$export$c28579e888e7e37b {
    constructor(labradorSamplingProvider, _experimentBucketProvider = (0, $38d16649fae24a5f$export$706c348d2e160d8b)()){
        this.bucketingProviders = {
            exp_bucket: _experimentBucketProvider,
            eb: labradorSamplingProvider
        };
    }
    match(group) {
        const bucketing = $03b3b9fef850175d$export$bf31116732bec244(group);
        if (!bucketing?.rules?.ranges || !bucketing.source) return undefined;
        const bucketingProvider = this.bucketingProviders[bucketing.source];
        if (!bucketingProvider) return undefined;
        const currentBucket = Math.round(bucketingProvider());
        const matchedRange = bucketing.rules.ranges.find((range)=>currentBucket >= range.start && currentBucket <= range.end);
        const enabledTraffic = Math.min(bucketing.rules.ranges.reduce((acc, range)=>acc + (range.end - range.start + 1), 0), 100);
        return {
            isActive: !!matchedRange,
            defaultKeyVal: bucketing.rules.defaultKeyValue,
            keyVal: matchedRange?.keyValue,
            enabledTraffic: enabledTraffic
        };
    }
}


var $c4e423976822797c$exports = {};

$parcel$export($c4e423976822797c$exports, "DeviceMatcher", () => $c4e423976822797c$export$b2a88ef241f2bd3f);

class $c4e423976822797c$export$b2a88ef241f2bd3f {
    constructor(currentDevice){
        this.currentDevice = currentDevice;
    }
    isValid(group) {
        const devices = group.d ?? group.devices ?? [];
        const deviceObjects = devices.map((browser)=>browser.toLowerCase()).map((browser)=>(0, $0669816a8a22a9c5$export$a3f4cf710f4ee0af)(browser));
        if (deviceObjects.length === 0) return true;
        if (!this.currentDevice) return true; // FIXME: na pewno? unit test
        if (this.isCurrentNegated(this.currentDevice, deviceObjects)) return false;
        return deviceObjects.some((object)=>object.value === this.currentDevice !== object.negated);
    }
    isCurrentNegated(currentDevice, deviceObjects) {
        return deviceObjects.some((object)=>currentDevice.includes(object.value) && object.negated);
    }
}


var $ae66becc9bc93fdf$exports = {};

$parcel$export($ae66becc9bc93fdf$exports, "DomainMatcher", () => $ae66becc9bc93fdf$export$48fd90bf831be0f8);
class $ae66becc9bc93fdf$export$48fd90bf831be0f8 {
    isValid(group) {
        const domains = group.o ?? group.domains ?? [];
        if (domains.length === 0) return true;
        return domains.some((domain)=>window.location.hostname.includes(domain));
    }
}



var $5c600f82de6d47cb$exports = {};

$parcel$export($5c600f82de6d47cb$exports, "RegionMatcher", () => $5c600f82de6d47cb$export$9dd39bf33dcd6ef6);

class $5c600f82de6d47cb$export$9dd39bf33dcd6ef6 {
    constructor(geo){
        this.geo = geo;
    }
    isValid(group, validateRegionPredicate) {
        const regions = group.r ?? group.regions ?? [];
        const validRegions = this.filterOutInvalidRegions(regions);
        return validateRegionPredicate ? validateRegionPredicate(validRegions) : this.isProperGeo(validRegions);
    }
    getCountryCode() {
        return this.geo?.country;
    }
    getRegionCode() {
        return this.geo?.region;
    }
    getContinentCode() {
        return this.geo?.continent;
    }
    isProperGeo(countryList = []) {
        return !!(countryList && countryList.indexOf && !this.isGeoExcluded(countryList) && (this.isProperContinent(countryList) || this.isProperCountry(countryList) || this.isProperRegion(countryList)));
    }
    filterOutInvalidRegions(regions) {
        return regions.filter((region)=>!region.includes((0, $d4594c0e01298382$export$8c99e8be8e35246))).filter((region)=>!region.includes((0, $d4594c0e01298382$export$4940459403f61e72)));
    }
    isProperCountry(countryList) {
        return !!(countryList && countryList.indexOf && (countryList.indexOf(this.getCountryCode()) > -1 || this.isSampledForGeo(countryList, this.getCountryCode())));
    }
    isProperRegion(countryList) {
        const code = `${this.getCountryCode()}-${this.getRegionCode()}`;
        return !!(countryList && countryList.indexOf && (countryList.indexOf(code) > -1 || this.isSampledForGeo(countryList, code)));
    }
    containsContinent(countryList) {
        const geo = `${(0, $d4594c0e01298382$export$aea6dbf29fd09cb3)}-${this.getContinentCode()}`;
        return countryList.indexOf(geo) > -1 || this.isSampledForGeo(countryList, geo);
    }
    containsWorldWide(countryList) {
        return countryList.indexOf((0, $d4594c0e01298382$export$aea6dbf29fd09cb3)) > -1 || this.isSampledForGeo(countryList, (0, $d4594c0e01298382$export$aea6dbf29fd09cb3));
    }
    isProperContinent(countryList) {
        return !!(countryList && countryList.indexOf && (this.containsWorldWide(countryList) || this.containsContinent(countryList)));
    }
    isGeoExcluded(countryList) {
        return !!(countryList.indexOf(`${(0, $d4594c0e01298382$export$6a1a21b83e21c671)}${this.getCountryCode()}`) > -1 || countryList.indexOf(`${(0, $d4594c0e01298382$export$6a1a21b83e21c671)}${this.getCountryCode()}-${this.getRegionCode()}`) > -1 || countryList.indexOf(`${(0, $d4594c0e01298382$export$6a1a21b83e21c671)}${(0, $d4594c0e01298382$export$aea6dbf29fd09cb3)}-${this.getContinentCode()}`) > -1);
    }
    hasSampling(geo) {
        return (value)=>value.indexOf((0, $d4594c0e01298382$export$6a1a21b83e21c671)) !== 0 && value.indexOf(geo + (0, $d4594c0e01298382$export$8c99e8be8e35246)) > -1;
    }
    getSamplingLimits(value) {
        let [, samplingValue] = value.split((0, $d4594c0e01298382$export$8c99e8be8e35246));
        samplingValue = samplingValue.replace((0, $d4594c0e01298382$export$4940459403f61e72), "");
        return Math.round(parseFloat(samplingValue) * (0, $d4594c0e01298382$export$b70eeb0e623ceb0d)) || 0;
    }
    isSampledForGeo(countryList, geo) {
        const countryListWithSampling = countryList.filter(this.hasSampling(geo));
        if (countryListWithSampling.length === 0) return false;
        const randomValue = Math.round(Math.random() * ((0, $d4594c0e01298382$export$b70eeb0e623ceb0d) * 100)) || 0;
        return countryListWithSampling.map((value)=>this.getSamplingLimits(value)).some((value)=>randomValue < value);
    }
}


var $af1a59bc0f676d02$exports = {};

$parcel$export($af1a59bc0f676d02$exports, "SamplingMatcher", () => $af1a59bc0f676d02$export$97fd11b48fd86f87);
class $af1a59bc0f676d02$export$97fd11b48fd86f87 {
    constructor(samplingProvider){
        this.samplingProvider = samplingProvider;
        this.precision = 10 ** 6;
    }
    isValid(sampling) {
        const randomValue = Math.round(this.samplingProvider() * this.precision);
        const thresholdValue = Math.round(sampling * this.precision);
        return randomValue < thresholdValue;
    }
}


$parcel$exportWildcard($a804696539f008f1$exports, $e6863e4cd836deaf$exports);
$parcel$exportWildcard($a804696539f008f1$exports, $03b3b9fef850175d$exports);
$parcel$exportWildcard($a804696539f008f1$exports, $c4e423976822797c$exports);
$parcel$exportWildcard($a804696539f008f1$exports, $ae66becc9bc93fdf$exports);
$parcel$exportWildcard($a804696539f008f1$exports, $0669816a8a22a9c5$exports);
$parcel$exportWildcard($a804696539f008f1$exports, $5c600f82de6d47cb$exports);
$parcel$exportWildcard($a804696539f008f1$exports, $af1a59bc0f676d02$exports);


class $d958a73fda15a350$export$482d435527222f10 {
    constructor(browserMatcher = new (0, $e6863e4cd836deaf$export$4505b7bf40f87994)(), deviceMatcher = new (0, $c4e423976822797c$export$b2a88ef241f2bd3f)(), domainMatcher = new (0, $ae66becc9bc93fdf$export$48fd90bf831be0f8)(), regionMatcher = new (0, $5c600f82de6d47cb$export$9dd39bf33dcd6ef6)(), settingsRepository){
        this.browserMatcher = browserMatcher;
        this.deviceMatcher = deviceMatcher;
        this.domainMatcher = domainMatcher;
        this.regionMatcher = regionMatcher;
        this.settingsRepository = settingsRepository;
        this.logGroup = "instant-config-interpreter";
        this.configResponse = {};
    }
    init(instantConfig, instantGlobals = {}, regionValidationPredicate, container = window) {
        this.configResponse = {
            ...instantGlobals,
            ...instantConfig
        };
        this.regionValidationPredicate = regionValidationPredicate;
        this.labradorKeyValuesMapper = new (0, $eb12f1054b8a7c9d$export$9c1e7db2884bc03)(this.getValue("icLABradorGamKeyValues"));
        const labradorBucketingProvider = new (0, $e60b87c9ea0c2612$export$43b1cb036f284cbe)(this.getValue("icExperimentBucket"), container, this.settingsRepository).build();
        this.deprecatedSamplingMatcher = new (0, $af1a59bc0f676d02$export$97fd11b48fd86f87)(labradorBucketingProvider);
        this.bucketingMatcher = new (0, $03b3b9fef850175d$export$c28579e888e7e37b)(labradorBucketingProvider, (0, $38d16649fae24a5f$export$706c348d2e160d8b)());
        return this;
    }
    getValues() {
        (0, $fde9406d76ec24a9$exports).logger(this.logGroup, "get values called with", this.configResponse);
        if (this.values === undefined) this.values = Object.keys(this.configResponse).reduce((acc, key)=>{
            acc[key] = this.getValue(key);
            return acc;
        }, {});
        return this.values;
    }
    getValue(key) {
        const value = this.configResponse[key];
        if ((0, $f871a27651c133e3$export$15fd8a4b2579d62a)(value)) {
            const group = value.find(this.predicate(key));
            return group?.v ?? group?.value;
        }
        return value;
    }
    getActiveKeyValues() {
        return this.labradorKeyValuesMapper.getActiveKeyValues();
    }
    getActiveLabradorKeyValues() {
        return this.labradorKeyValuesMapper.getActiveLabradorKeyValues();
    }
    predicate(key) {
        return (group)=>{
            const value = this.browserMatcher.isValid(group) && this.deviceMatcher.isValid(group) && this.domainMatcher.isValid(group) && this.regionMatcher.isValid(group, this.regionValidationPredicate);
            const bucketing = (0, $03b3b9fef850175d$export$bf31116732bec244)(group);
            if (bucketing && value) {
                const bucketingMatcherResult = this.bucketingMatcher.match(group);
                if (bucketingMatcherResult) {
                    this.labradorKeyValuesMapper.mark(key, bucketingMatcherResult);
                    return bucketingMatcherResult.isActive;
                }
            }
            if (!(0, $f871a27651c133e3$export$f348545466c9b18e)(group) || value === false) return value;
            /**
			 * @deprecated
			 */ const sampling = group?.s ?? group?.sampling;
            const active = this.deprecatedSamplingMatcher.isValid(sampling);
            this.labradorKeyValuesMapper.deprecatedMark(key, sampling, active);
            return active;
        };
    }
}


var $892ee10bae897d26$exports = {};

$parcel$export($892ee10bae897d26$exports, "InstantConfigLoader", () => $892ee10bae897d26$export$f46cdbfb0a457ef7);


async function $ce1eb12f11cf610a$export$a986389b0f83d258(url, timeout = 2000) {
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeout);
    const response = await fetch(url, {
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}


const $892ee10bae897d26$var$logGroup = "instant-config-loader";
const $892ee10bae897d26$var$instantConfigKey = "instantConfig";
class $892ee10bae897d26$export$f46cdbfb0a457ef7 {
    constructor(params, container = window){
        this.params = params;
        this.container = container;
        this.storage = new (0, $fde9406d76ec24a9$exports).localStorageHelper(`instant-config-${params.appName}`, 60000);
        this.container.icbm = this.container.icbm || {};
        this.instantConfig = this.container[$892ee10bae897d26$var$instantConfigKey];
        this.lockDelay = typeof params.lockDelay === "number" ? params.lockDelay : 500;
    }
    async getConfig() {
        if (this.instantConfig) return this.instantConfig;
        let configFetch;
        if (this.lockDelay > 0) configFetch = this.fetchInstantConfigThroughCache();
        else {
            if (!this.container.icbm.fetch) this.container.icbm.fetch = this.fetchInstantConfig();
            configFetch = this.container.icbm.fetch;
        }
        return configFetch.then((config)=>config ?? this.fetchFallbackConfig());
    }
    async fetchInstantConfigThroughCache(fallback = false) {
        const locked = (0, $fde9406d76ec24a9$exports).lock();
        if (locked && !fallback) {
            (0, $fde9406d76ec24a9$exports).logger($892ee10bae897d26$var$logGroup, "locked, awaiting", this.lockDelay);
            await (0, $03ed50ec9aa498e4$export$1391212d75b2ee65)(this.lockDelay);
            // try again, if lock is still present then try LocalStorage or fetch from ICBM
            return this.fetchInstantConfigThroughCache(true);
        }
        try {
            const cachedConfigString = this.storage.get();
            if (cachedConfigString) {
                (0, $fde9406d76ec24a9$exports).logger($892ee10bae897d26$var$logGroup, "instant config pulled from local storage", cachedConfigString);
                // YES, we don't release lock here as this BUG is protecting Document Load time
                // ultimate fix will be done with removal of the lock and cache logic in favour of DOM wait
                return JSON.parse(cachedConfigString);
            }
            const config = await this.fetchInstantConfig();
            if (config) this.storage.set(JSON.stringify(config));
            (0, $fde9406d76ec24a9$exports).release();
            return config;
        } catch (err) {
            (0, $fde9406d76ec24a9$exports).warner($892ee10bae897d26$var$logGroup, "could not get instant config via cache", err);
            (0, $fde9406d76ec24a9$exports).release();
        }
    }
    async fetchInstantConfig() {
        const baseUrl = this.params.instantConfigEndpoint ?? "https://services.fandom.com";
        const variant = this.params.instantConfigVariant ?? "icbm";
        const { appName: appName , compact: compact  } = this.params;
        const queryParams = new URLSearchParams({
            app: appName
        });
        if (compact) queryParams.set("compact", "true");
        const url = `${baseUrl}/${variant}/api/config?${queryParams.toString()}`;
        try {
            const response = await (0, $ce1eb12f11cf610a$export$a986389b0f83d258)(url, this.params.requestTimeout);
            if (!response.ok) return undefined;
            const instantConfig = await response.json();
            (0, $fde9406d76ec24a9$exports).logger($892ee10bae897d26$var$logGroup, "instant config fetched", instantConfig);
            return instantConfig;
        } catch (err) {
            (0, $fde9406d76ec24a9$exports).warner($892ee10bae897d26$var$logGroup, "could not fetch instant config", err);
            return undefined;
        }
    }
    async fetchFallbackConfig() {
        (0, $fde9406d76ec24a9$exports).logger($892ee10bae897d26$var$logGroup, "Fetching fallback config");
        const fallbackEndpoint = this.params.instantConfigFallbackEndpoint;
        if (typeof fallbackEndpoint === "undefined") return {};
        try {
            (0, $fde9406d76ec24a9$exports).logger($892ee10bae897d26$var$logGroup, fallbackEndpoint);
            const response = await (0, $ce1eb12f11cf610a$export$a986389b0f83d258)(fallbackEndpoint, this.params.requestTimeout);
            if (!response.ok) return {};
            const fallbackConfig = await response.json();
            (0, $fde9406d76ec24a9$exports).logger($892ee10bae897d26$var$logGroup, "fallback config fetched", fallbackConfig);
            return fallbackConfig;
        } catch (err) {
            (0, $fde9406d76ec24a9$exports).warner($892ee10bae897d26$var$logGroup, "could not fetch fallback config", err);
            return {};
        }
    }
}


var $fc51f0a6288ce2c6$exports = {};

$parcel$export($fc51f0a6288ce2c6$exports, "InstantConfigOverrider", () => $fc51f0a6288ce2c6$export$14a2f5ed2c1a484d);
const $fc51f0a6288ce2c6$var$queryParamPrefixes = [
    "InstantGlobals",
    "icbm"
];
function $fc51f0a6288ce2c6$var$hasInstantConfigPrefix(key) {
    return $fc51f0a6288ce2c6$var$queryParamPrefixes.some((prefix)=>{
        return key.startsWith(`${prefix}.`) || key.startsWith(`${prefix}__`);
    });
}
class $fc51f0a6288ce2c6$export$14a2f5ed2c1a484d {
    override(queryString, config) {
        return [
            ...queryString.keys()
        ].filter((paramKey)=>$fc51f0a6288ce2c6$var$hasInstantConfigPrefix(paramKey)).map((paramKey)=>{
            const [, key] = paramKey.split(".").map((part)=>part.split("__")).flat();
            return {
                paramKey: paramKey,
                key: key
            };
        }).map(({ paramKey: paramKey , key: key  })=>({
                key: key,
                value: this.parseValue(queryString.get(paramKey))
            })).reduce((newConfig, { key: key , value: value  })=>({
                ...newConfig,
                [key]: value
            }), config);
    }
    parseValue(value) {
        if (value === "true" || value === "false") return value === "true";
        const intValue = parseInt(value, 10);
        if (value === `${intValue}`) return intValue;
        try {
            return JSON.parse(value);
        } catch (ignore) {
            return value || null;
        }
    }
}



$parcel$exportWildcard($a3cb38fbe085f101$exports, $d958a73fda15a350$exports);
$parcel$exportWildcard($a3cb38fbe085f101$exports, $892ee10bae897d26$exports);
$parcel$exportWildcard($a3cb38fbe085f101$exports, $fc51f0a6288ce2c6$exports);
$parcel$exportWildcard($a3cb38fbe085f101$exports, $a804696539f008f1$exports);





export {$d958a73fda15a350$export$482d435527222f10 as InstantConfigInterpreter, $892ee10bae897d26$export$f46cdbfb0a457ef7 as InstantConfigLoader, $fc51f0a6288ce2c6$export$14a2f5ed2c1a484d as InstantConfigOverrider, $e6863e4cd836deaf$export$4505b7bf40f87994 as BrowserMatcher, $03b3b9fef850175d$export$bf31116732bec244 as getBucketing, $03b3b9fef850175d$export$c28579e888e7e37b as BucketingMatcher, $c4e423976822797c$export$b2a88ef241f2bd3f as DeviceMatcher, $ae66becc9bc93fdf$export$48fd90bf831be0f8 as DomainMatcher, $0669816a8a22a9c5$export$a3f4cf710f4ee0af as extractNegation, $5c600f82de6d47cb$export$9dd39bf33dcd6ef6 as RegionMatcher, $af1a59bc0f676d02$export$97fd11b48fd86f87 as SamplingMatcher, $f871a27651c133e3$export$15fd8a4b2579d62a as shouldBeListOfConfigGroups, $f871a27651c133e3$export$f348545466c9b18e as hasSampling, $d4594c0e01298382$export$6a1a21b83e21c671 as negativePrefix, $d4594c0e01298382$export$4940459403f61e72 as cacheSuffix, $d4594c0e01298382$export$8c99e8be8e35246 as samplingSeparator, $d4594c0e01298382$export$aea6dbf29fd09cb3 as worldWide, $d4594c0e01298382$export$b70eeb0e623ceb0d as precision, $d4594c0e01298382$export$120f2aee7d622861 as experimentBucketSettingKey};
//# sourceMappingURL=index.esm.js.map
